import React, { useState } from 'react';
import { Phone, ArrowRight, Star } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../data/mockData';

export const Hero = () => {
  const [isBookingOpen, setIsBookingOpen] = useState(false);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1765064520245-2baac5e82689?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjB0cmVlJTIwcmVtb3ZhbHxlbnwwfHx8fDE3NzM5NTI1ODZ8MA&ixlib=rb-4.1.0&q=85"
          alt="Professional Tree Service"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 pt-20">
        <div className="max-w-4xl">
          {/* Rating Badge */}
          <div className="inline-flex items-center space-x-2 bg-green-500/20 backdrop-blur-sm border border-green-400/30 rounded-full px-4 py-2 mb-6 animate-fade-in">
            <div className="flex items-center space-x-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-green-400 text-green-400" />
              ))}
            </div>
            <span className="text-white font-semibold">{companyInfo.rating}</span>
            <span className="text-gray-300">({companyInfo.totalReviews} Reviews)</span>
          </div>

          {/* Main Headline */}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight animate-slide-up">
            Nashville's Most{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-green-600">
              Trusted
            </span>
            <br />
            Tree Service Experts
          </h1>

          {/* Subheadline */}
          <p className="text-xl md:text-2xl text-gray-200 mb-4 animate-slide-up animation-delay-200">
            24/7 Emergency Tree Removal • Licensed • Insured • Family-Owned
          </p>

          <p className="text-lg text-gray-300 mb-10 max-w-2xl animate-slide-up animation-delay-400">
            Professional tree care and landscaping services you can trust. Over a decade of experience serving Nashville and surrounding communities.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 animate-slide-up animation-delay-600">
            <a href={`tel:${companyInfo.phone.replace(/\D/g, '')}`}>
              <Button className="bg-green-500 hover:bg-green-600 text-white font-bold text-lg px-8 py-6 rounded-lg shadow-lg hover:shadow-green-500/50 transition-all duration-300 transform hover:scale-105 w-full sm:w-auto">
                <Phone className="w-5 h-5 mr-2" />
                Call {companyInfo.phone}
              </Button>
            </a>
            <Button
              onClick={() => {
                document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-white hover:bg-gray-100 text-black font-bold text-lg px-8 py-6 rounded-lg shadow-lg transition-all duration-300 transform hover:scale-105 w-full sm:w-auto"
            >
              Get Free Estimate
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16 animate-fade-in animation-delay-800">
            <div className="text-center">
              <div className="text-4xl font-bold text-green-400 mb-2">10+</div>
              <div className="text-gray-300">Years Experience</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-green-400 mb-2">24/7</div>
              <div className="text-gray-300">Emergency Trees</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-green-400 mb-2">100%</div>
              <div className="text-gray-300">Licensed & Insured</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-green-400 mb-2">500+</div>
              <div className="text-gray-300">Happy Customers</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};
